<template>
  <div class="py-3">
    <div class="row mb-3">
      <div class="col-lg-7 col-sm-6 text-left">
        <div :class="{ 'd-none': hasTouchEvents }" class="pt-2">
          Drag projects to sort them.
        </div>
      </div>

      <div class="col-lg-5 col-sm-6">
        <div class="form-group form-inline">
          <div class="pr-2">
            <label for="manage-projects-search-by"> Filter by: </label>
          </div>

          <input
            id="manage-projects-search-by"
            v-model="search"
            class="form-control"
            placeholder="project name..."
            type="text"
          />

          <a
            v-if="search"
            class="clear-search"
            href="#"
            v-on:click="clearSearch()"
          >
            <i class="material-icons">close</i>
          </a>
        </div>

        <div style="float: right">
          <a
            class="btn btn-xxs font-weight-semibold d-inline-block mt-0"
            :class="deleteBtnState"
            href="#"
            @click="deleteCheckedProjects"
          >
            Delete Selected
          </a>
        </div>
      </div>
    </div>

    <div>
      <div
        v-if="projects.length"
        class="border border-light p-2 card-project-sortable"
        style="height: 580px; overflow-y: auto"
      >
        <div
          v-for="(project, index) in projects"
          v-if="project.id != authenticatedUserQuicklistId && search == ''"
          v-bind:id="'manage-projects-sortable-project-id-' + project.id"
          :key="project.id"
          :class="{ 'bg-aztec-grey': !project.color }"
          :style="{ backgroundColor: project.color }"
          class="card card-body border-dark small p-2 mb-2 d-block draggable-cursor"
        >
          <a class="text-white" href="#" @click="projectClick(project.id)">
            {{ index + 1 + ") " + project.name }} ({{ project.trackcount }}
            tracks)
          </a>
          <span class="float-left">
            <i class="material-icons">{{
              hasTouchEvents ? "menu" : "drag_handle"
            }}</i>
          </span>
          <input
            type="checkbox"
            class="float-right m-1"
            :checked="projectsChecked.some((p) => p.id === project.id)"
            @change="toggleProjectChecked(project)"
          />
          <a
            class="float-right text-white"
            href="#"
            v-on:click.prevent="deleteProject(project)"
          >
            <i
              class="material-icons"
              data-placement="top"
              data-toggle="tooltip"
              title="Delete project"
            >
              delete
            </i>
          </a>
          <a
            class="d-block float-right text-white"
            data-dismiss="modal"
            href="#"
            v-on:click.prevent="shareProject(project)"
          >
            <i
              class="material-icons"
              data-placement="top"
              data-toggle="tooltip"
              title="Share/email project"
            >
              share
            </i>
          </a>
        </div>

        <div
          v-for="(project, index) in filteredProjects"
          v-if="project.id != authenticatedUserQuicklistId && search != ''"
          v-bind:id="'manage-projects-sortable-project-id-' + project.id"
          :key="project.id"
          :class="{ 'bg-aztec-grey': !project.color }"
          :style="{ backgroundColor: project.color }"
          class="card card-body border-dark small p-2 mb-2 d-block draggable-cursor"
        >
          <a class="text-white" href="#" @click="projectClick(project.id)">
            {{ index + 1 + ") " + project.name }} ({{ project.trackcount }}
            tracks)
          </a>
          <span class="float-left">
            <i class="material-icons">{{
              hasTouchEvents ? "menu" : "drag_handle"
            }}</i>
          </span>
          <input
            type="checkbox"
            class="float-right m-1"
            :checked="projectsChecked.some((p) => p.id === project.id)"
            @change="toggleProjectChecked(project)"
          />
          <a
            class="float-right text-white"
            href="#"
            v-on:click.prevent="deleteProject(project)"
          >
            <i
              class="material-icons"
              data-placement="top"
              data-toggle="tooltip"
              title="Delete project"
            >
              delete
            </i>
          </a>
          <a
            class="d-block float-right text-white"
            data-dismiss="modal"
            href="#"
            v-on:click.prevent="shareProject(project)"
          >
            <i
              class="material-icons"
              data-placement="top"
              data-toggle="tooltip"
              title="Share/email project"
            >
              share
            </i>
          </a>
        </div>
      </div>

      <div
        v-if="!projects.length"
        class="card card-body bg-aztec-grey border-dark"
      >
        You currently have no Projects.
      </div>

      <a
        class="btn btn-raised btn-aztec-grey btn-xl font-weight-semibold d-inline-block mt-3"
        href="#"
        v-on:click.prevent="onNewProjectClick"
      >
        New Project
      </a>

      <a
        aria-label="Close"
        class="btn btn-raised btn-danger btn-xl font-weight-semibold d-inline-block mt-3"
        data-dismiss="modal"
        href="#"
      >
        Close
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import "jquery-ui-touch-punch";

export default Vue.component("manage-projects", {
  data: function () {
    return {
      projects: [],
      projectsChecked: [],
      search: "",
      authenticatedUserQuicklistId: window.authenticatedUserQuicklistId,
    };
  },

  computed: {
    filteredProjects() {
      if (this.search == null) {
        return [];
      }

      return this.projects.filter((project) => {
        return (
          project.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });
    },

    hasTouchEvents() {
      return Modernizr.touchevents == true;
    },

    deleteBtnState() {
      const isProjectsCheckedEmpty = this.projectsChecked.length === 0;
      return {
        disabled: isProjectsCheckedEmpty,
        "btn-disabled": isProjectsCheckedEmpty,
        "btn-danger": !isProjectsCheckedEmpty,
      };
    },
  },

  updated: function () {
    this.initialiseSortable();

    window.webpackDestroyBsTooltipWorkaround(
      $(this.$el).find('[data-toggle="tooltip"]'),
    );

    // Initialise our tooltips manually.
    window.webpackReinitBsTooltipWorkaround(
      $(this.$el).find('[data-toggle="tooltip"]'),
    );
  },

  mounted: function () {
    playerService.$on("user-updated", () => {
      this.authenticatedUserQuicklistId = window.authenticatedUserQuicklistId;
    });

    playerService.$on("open-manage-projects", () => {
      // Open the modal.
      window.webpackOpenBsModalWorkaround("#manageProjectsModal");

      this.reset();
    });

    // Keep our projects for the component up to date.
    playerService.$on("projects-updated", (projects) => {
      this.projects.splice(0, this.projects.length);

      for (let projectId in projects) {
        if (projects.hasOwnProperty(projectId)) {
          if (
            typeof projects[projectId].color == "undefined" ||
            projects[projectId].color == "false" ||
            projects[projectId].color == false
          ) {
            projects[projectId].color = null;
          }

          if (window.authenticatedUserQuicklistId != projects[projectId].id) {
            this.projects.push(projects[projectId]);
          }
        }
      }
    });

    playerService.$on("project-added", (project) => {
      if (
        typeof project.color == "undefined" ||
        project.color == "false" ||
        project.color == false
      ) {
        project.color = null;
      }

      if (window.authenticatedUserQuicklistId != project.id) {
        this.projects.push(project);
      }
    });
  },

  methods: {
    projectClick: function (projectId) {
      // Close the modal.
      window.webpackCloseBsModalWorkaround("#manageProjectsModal");

      // Scroll Project to View
      playerService.$emit("scroll-project-to-view", projectId);
    },

    toggleProjectChecked(project) {
      const idx = this.projectsChecked.findIndex((p) => p.id === project.id);
      if (idx === -1) {
        this.projectsChecked = [...this.projectsChecked, project];
      } else {
        const next = this.projectsChecked.slice();
        next.splice(idx, 1);
        this.projectsChecked = next;
      }
    },

    deleteCheckedProjects: function () {
      this.projectsChecked.forEach((p) => {
        playerService.deleteProject(p);
      });
      this.projectsChecked = [];
      window.webpackCloseBsModalWorkaround("#manageProjectsModal");
    },

    clearSearch: function () {
      this.search = "";
    },

    // Deletes a project completely
    deleteProject: function (project) {
      // Close the modal.
      window.webpackCloseBsModalWorkaround("#manageProjectsModal");

      playerService.$emit("open-delete-project-modal", project);
    },

    shareProject: function (project) {
      playerService.$emit("share-project", project);
    },

    save: function () {
      let rawSortedProjects = window.sortableToArrayWrapper(
        ".card-project-sortable",
      );
      let sortedProjectIds = rawSortedProjects.map(function (value, index) {
        return {
          id: value.replace("manage-projects-sortable-project-id-", ""),
          order: index,
        };
      });

      playerService.saveManageProjects(sortedProjectIds);
    },

    instantsave: function () {
      let rawSortedProjects = window.sortableToArrayWrapper(
        ".card-project-sortable",
      );
      let sortedProjectIds = rawSortedProjects.map(function (value, index) {
        return {
          id: value.replace("manage-projects-sortable-project-id-", ""),
          order: index,
        };
      });

      playerService.instantsaveManageProjects(sortedProjectIds);
    },

    updated: function () {
      let rawSortedProjects = window.sortableToArrayWrapper(
        ".card-project-sortable",
      );
      let sortedProjectArr = [];
      rawSortedProjects.forEach(function (value, index) {
        let sortedProjectData = {
          id: value.replace("manage-projects-sortable-project-id-", ""),
          order: index,
        };

        sortedProjectArr[sortedProjectData.id] = sortedProjectData;
      });

      let onNewProjectClicks = [];

      for (let projectIndex in this.projects) {
        if (this.projects.hasOwnProperty(projectIndex)) {
          let project = this.projects[projectIndex];

          if (typeof sortedProjectArr[project.id] !== "undefined") {
            project.order = sortedProjectArr[project.id].order;

            onNewProjectClicks.push(project);
          }
        }
      }

      this.projects = onNewProjectClicks;

      this.instantsave();
    },

    reset: function () {
      this.search = "";
      this.projectsChecked = [];
    },

    initialiseSortable: function () {
      let ctx = this;
      this.initialisedSortable = true;

      // Re-initialise it for this selector.
      let sortableConfig = {
        placeholder: "ui-state-highlight",
        update: function (event, ui) {
          ctx.updated();
        },
      };

      // On touch devices, only allow dragging via the handle to prevent interference with scrolling
      if (this.hasTouchEvents) {
        sortableConfig.handle = ".float-left";
      }

      window.sortableWrapper(".card-project-sortable", sortableConfig);
    },

    // Handler for what happens when we click the new project button.
    onNewProjectClick: function () {
      // Auto close the modal before the new one (create) will open.
      window.webpackCloseBsModalWorkaround("#manageProjectsModal");

      // let the player service we want to create a new project.
      playerService.addProject();
    },
  },
});
</script>
